import { render } from "./TimeSystemAxis.vue?vue&type=template&id=d8fb78d4"
import script from "./TimeSystemAxis.vue?vue&type=script&lang=js"
export * from "./TimeSystemAxis.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__